import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { ToolbarItem } from '../../../shared/interfaces/tool-bar-item.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { INotificationService } from '../../../shared/services/inotification.service';
import { FeedbackMessageService } from '../../../shared/services/feedback-message.service';
import { DetailService } from '../../../core/services/detail.service';
import { HttpErrorResponse } from '@angular/common/http';
import { BaseComponent } from '../../../core/models/base-component.model';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { SVGIcon, arrowUpIcon, arrowDownIcon, trashIcon } from '@progress/kendo-svg-icons';
import { Item } from '../../../shared/interfaces/entities/item.interface';
import { AuthenticationService } from '../../../core/services/authentication.serivce';
import { Cart } from '../../../core/interfaces/cart.interface';
import { ItemService } from '../services/item-service';
import { CartService } from '../../../shared/services/cart.service';
import { SideCartComponent } from '../../../shared/components/side-cart/side-cart.component';
import { ImageEntity } from '../../../shared/interfaces/entities/image.interface';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { State, process } from '@progress/kendo-data-query';
import { AddonItemFilter } from '../../../shared/interfaces/select-filters/addon-item-filter.interface';
import { AddOnOptionsSelect } from '../../../shared/ui/select-controls/add-on-options-select.model';

@Component({
    selector: 'app-add-to-cart',
    templateUrl: './add-to-cart.component.html',
    styleUrls: ['./add-to-cart.component.css'],
    standalone: false
})

export class AddToCartComponent extends BaseComponent implements OnInit {

  id: string;
  entity: Item;

  addonOptionId: AddOnOptionsSelect;
  showAddonOptions: boolean = false;

  itemImageResults: ImageEntity[] = [];
  public itemImageGridState: State = {
    sort: [],
    skip: 0,
    take: 10
  };

  public itemImageGridData: GridDataResult = process(this.itemImageResults, this.itemImageGridState);
  imageData = [];
  public items: ImageEntity[] = this.imageData;

  public width = "110%";
  public height = "500px";

  cartItems: any;

  form: FormGroup;

  showReturnOrder: boolean;

  formControls: { [k: string]: FormControl } = {};
  submitted: boolean = false;
  toolbarItems: ToolbarItem[] = [];
  cart: Cart[] = [];
  test: Cart;

  isEmpty: boolean = false;

  public svgUpArrow: SVGIcon = arrowUpIcon;
  public svgDownArrow: SVGIcon = arrowDownIcon;
  public svgTrash: SVGIcon = trashIcon;
  constructor(private activatedRouter: ActivatedRoute,
    private router: Router,
    private detailService: DetailService<any>,
    private auth: AuthenticationService,
    private fb: FormBuilder,
    private feedback: FeedbackMessageService,
    private itemService: ItemService,
    private notificationService: INotificationService,
    private cartService: CartService) {
    super();

    this.activatedRouter.params.subscribe(params => this.id = params['id']);
  }

  ngOnInit(): void {

    this.addonOptionId = new AddOnOptionsSelect("addonOptionId", "Add On Options", null);

    var ramOptionFilter: AddonItemFilter = {
      itemId: Number(this.id)
    };

    this.addonOptionId.filters = ramOptionFilter;

    this.form = this.fb.group({
      quantity: [1],
      itemId: this.id,
      organizationId: this.auth.getOrganizationId(),
      isLegalHold: false,
      isReturnOrder: false,
      addonOptionId: [null]
    });

    this.itemService.getItemImages(this.id).subscribe((data => {
      this.itemImageGridData = process(data, this.itemImageGridState);
      this.itemImageResults = data;
      this.items = data;

      if (data.length == 0) { this.isEmpty = true };
    }));


    try {
      var session = this.auth.getSession();

        this.detailService.byId("Item", this.id)
          .pipe(takeUntil(this.subscription))
          .subscribe({
            next: (data: any) => {
              this.entity = data;

              if (Object.keys(this.entity.itemAddonOptions).length > 0) {
                this.showAddonOptions = true;
              }

              //check if this record matches the current organizationId
              if (this.entity.organizationId != session?.organizationId) {
                this.router.navigate(['']);
                this.notificationService.show({ title: "Error!", type: "error", description: "You are not allowed to view this due to organization" });
              }

              var countriesUserHasAccessTo = session?.countryList.map(obj => obj.id);
              //check if this record matches the user's country/countries
              if (!countriesUserHasAccessTo?.includes(this.entity.countryId)) {
                this.router.navigate(['']);
                this.notificationService.show({ title: "Error!", type: "error", description: "You are not allowed to view this due to country! Please reach out to your administrator." });
              }

            },
            error: (e: HttpErrorResponse) => {
              var errorMsg: string = e.error;
              if (typeof e.error === "object") {
                errorMsg = e.statusText
              }

              this.notificationService.show({ title: "Error", description: errorMsg.substring(0, 100), type: "error" });
            }
          });
    } catch (err) {
      console.log(err);
    }
  }

  //We need to check that they have the quantity, return label required and legal hold required
  addToCart(): void {
    // Process cart data here
    this.form.value.itemTitle = this.entity.title;

    var addonOptionId = this.addonOptionId.getValue();

    if (addonOptionId != "") {
      this.form.controls['addonOptionId'].setValue(Number(addonOptionId));
    } else {
      this.form.controls['addonOptionId'].setValue(null);
    }


    this.cartService.addToCart(this.form.value).subscribe((data => {
      if (data.wasSuccessful) {

        //refresh the cart data
        this.cartService.setRefresh(true);

        //after it's added, open up the cart window
        var wrapper = document.getElementsByClassName('wrapper')[0];
        wrapper.classList.toggle('opened');

        if (wrapper.className.includes("opened")) {
          //add overlay
          document.getElementById('cartOverlay')?.classList.add('k-overlay');
        }
      } else {
        this.notificationService.show({ type: 'error', title: 'Error!', description: data.message });
      }
    }));
  }

  toggleReturnOrder(value: any) {
    var legalHoldSection = document.getElementById('legalHoldSection') as HTMLInputElement;

    if (legalHoldSection.style.display === "none") {
      legalHoldSection.style.display = "block";
    } else {
      legalHoldSection.style.display = "none";

      //Hide it and clear it's content
      legalHoldSection.checked = false;
    }
  }
}




